import React, { useMemo } from "react";
import { useRecoilState } from "recoil";
import ScreenCard from "../ScreenCard";
import { newMissionState } from "../../atoms/core";
import { CreateMissionScreensContext } from "../../contexts/CreateMissionManager";
import { useI18n } from "../../hooks/i18n-hooks";
import WorkingTimeEditor from "../../components/working_time/WorkingTimeEditor";
import { DEFAULT_HOURS_PER_WEEK, MINIMUM_SLOT_DURATION_HOURS } from "../../utils";
import { useHasErrorWorkingTimeClassicSpec } from "../../components/working_time/helpers";
import { Unit } from "../../__generated__/graphql";
import { Bubble } from "../../components/Bubble";
import { useBubbleStepOrigin } from "../../hooks/use-bubble-step-origin";

const CreateMissionWorkingTimeMore = () => {
    const i18n = useI18n();
    const [mission, setMission] = useRecoilState(newMissionState);

    const { validateScreen } = React.useContext(CreateMissionScreensContext);
    const validate = React.useCallback(() => {
        void validateScreen("CreateMissionWorkingTimeMore");
    }, [validateScreen]);
    const hasErrorWorkingTimeClassicSpec = useHasErrorWorkingTimeClassicSpec();

    const { hasError } = useMemo(() => {
        const hoursPerWeek =
            mission.currentContract?.hoursPerWeekFullTime || DEFAULT_HOURS_PER_WEEK;
        return hasErrorWorkingTimeClassicSpec(
            mission.currentContract?.workingTimeClassicSpec?.unit || Unit.Hours,
            mission.currentContract?.workingTimeClassicSpec?.repetition,
            Number(mission.currentContract?.workingTimeClassicSpec?.unitCount),
            hoursPerWeek,
            Number(mission.currentContract?.workingTimeClassicSpec?.dailyHours),
        );
    }, [
        hasErrorWorkingTimeClassicSpec,
        mission.currentContract?.hoursPerWeekFullTime,
        mission.currentContract?.workingTimeClassicSpec?.repetition,
        mission.currentContract?.workingTimeClassicSpec?.unitCount,
        mission.currentContract?.workingTimeClassicSpec?.dailyHours,
        mission.currentContract?.workingTimeClassicSpec?.unit,
    ]);

    const isValid = useMemo(() => {
        let dailyIsValid = true;
        if (mission.currentContract?.workingTimeClassicSpec?.unit === Unit.Days) {
            dailyIsValid = !!mission.currentContract?.workingTimeClassicSpec?.dailyHours;
        }
        return !!(
            mission.currentContract?.workingTimeClassicSpec?.repetition &&
            mission.currentContract?.workingTimeClassicSpec?.unit &&
            !!mission.currentContract.workingTimeClassicSpec.unitCount &&
            mission.currentContract.workingTimeClassicSpec.unitCount >=
                MINIMUM_SLOT_DURATION_HOURS &&
            dailyIsValid &&
            !hasError
        );
    }, [hasError, mission.currentContract]);

    const origin = useBubbleStepOrigin("CreateMissionWorkingTimeMore");

    return (
        <ScreenCard
            buttons={[
                {
                    title: i18n.translate("next"),
                    onPress: validate,
                    isValid: isValid,
                },
            ]}
        >
            <Bubble
                title={i18n.t("screens.user.create_mission_working_time_more.title")}
                origin={origin}
                bubbleStyle={{ paddingBottom: 0 }}
            >
                <WorkingTimeEditor mission={mission} setMission={setMission} />
            </Bubble>
        </ScreenCard>
    );
};

export default CreateMissionWorkingTimeMore;
